<template>
    <nav>
        <router-link to="/" class="link home-link"><h3>DA</h3></router-link>

        <router-link to="/projects" class="link main-link"><h4>Work</h4></router-link>
        <router-link to="/about" class="link main-link"><h4>About</h4></router-link>
        <a href="mailto:dancaraujo@gmail.com" class="link main-link"><h4>Email</h4></a>
        <a href="https://www.linkedin.com/in/dancaraujo" target="_blank" class="link main-link"><h4>LinkedIn</h4></a>
    </nav>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>

nav {
    position: fixed;
    transform: rotate(90deg) translate(5px, -37px);
    transform-origin: center left;
    width: 90vh;
    display: none;

    @include phone-only {
        display: none;
    }
}

.link {
    text-decoration: none;
    user-select: none;
    float: left;
    transition: color .2s ease-out;
    margin-right: $grid-gap;
    display: flex;
    align-items: center;
    height: 50px;

    h3, h4 {
        white-space: nowrap;
        // text-transform: uppercase;
        transition: color .2s ease-out;
        position: relative;

    }

    &:hover h3 {
        color: $gray7;
        cursor: pointer;

        &:before {
            transform-origin: center left;
            transform: scaleY(1);
        }
    }

    &:hover h4 {
        color: $gray8;

        &:before {
            transform-origin: bottom left;
            transform: scaleX(1);
        }
    }

    h3 {
        color: $white;
        text-transform: uppercase;
        font-family: $display-font;
        font-size: 2rem;

        z-index: 1;
        position: relative;
        padding: 0.5rem 1rem;
        outline: none;
        border: none;
        background-color: $gray8;

        &:before {
            content: '';
            z-index: -1;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: $white;
            transform-origin: center right;
            transform: scaleX(0);
            transition: transform 0.25s ease-in-out;
        }
    }

    h4 {
        color: $gray4;
        font-family: $display-font;
        font-size: 1.075rem;
        text-shadow: -2px -2px 0 $gray1, 2px -2px 0 $gray1, -2px 2px 0 $gray1, 2px 2px 0 $gray1;

        &:before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 3px;
            background-color: $gray3;
            transform-origin: bottom right;
            transform: scaleX(0);
            transition: transform 0.2s ease-out;
        }

    }
}

.main-link {
    @include phone-only {
        display: none;
    }
}

</style>
